import colors from 'theme/colors';
import styled from 'styled-components/native';

const SafeAreaView = styled.SafeAreaView`
  background-color: ${colors.ORANGE};
`;
export default SafeAreaView;
